import * as React from "react";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Button, Box } from "@mui/material";
import "../blockpay.css";
import axios from "axios";
import { setAuthToken } from "../../utils/setAuthToken";
import { useNavigate } from "react-router-dom";

export default function Deposits(props) {
  //useStates
  const [bal, setBal] = React.useState("");
  const navigate=useNavigate();
  const getBal = (e) => {
    // e.preventDefault();
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .get("https://api.blockpay.co.za/blockchain/allBalances", {})
      .then((res) => {
        setBal(res.data.totalBalance);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  React.useEffect(() => {
    getBal();
  }, []);
  return (
    <React.Fragment>
      <Box sx={{ textAlign: "left", bottom: 0 }}>
        <Button
          className="loginButtonSignUp"
          variant="contained"
          color="primary"
          size="large"
          sx={{ marginTop: "0!important", width: "10rem", float: "right" }}
          component={Link}
          to="/withdraw"
        >
            <span>Withdraw</span>
          
        </Button>
        <Box
          component="img"
          sx={{ height: "80px", marginBottom: "25px" }}
          alt="Image"
          src={props.img}
        />

        <Typography
          component="p"
          variant="body1"
          sx={{
            color: "white",
            fontWeight: "400",
            fontSize: "1.125rem",
            width: "100%",
            marginBottom: "0.8rem",
          }}
        >
          {props.data}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            flex: 1,
            color: "white",
            fontSize: "2rem",
            fontWeight: "600",
            lineHeight: "2.125rem",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.5rem",
              lineHeight: "1.8rem!important",
              fontWeight: 600,
            }}
          >
            R
          </Typography>
          &nbsp;{bal}
        </Typography>
      </Box>
    </React.Fragment>
  );
}
